import { useRef } from "react";
import { Helmet } from "react-helmet";
import LandingNav from "./LandingNav";
import LandingFooter from "./LandingFooter";
import useLandingMotion from "./useLandingMotion";
import useLandingTheme from "./useLandingTheme";
import Seo from "../Seo";
import "../../landing.css";

// Marco de las páginas informativas (preguntas frecuentes, términos y privacidad), con el estilo de la landing.
// narrow centra el título en el ancho de la columna de preguntas.
const InfoLayout = ({ title, description, path, jsonLd, eyebrow, heading, subheading, narrow, children }) => {

    const rootRef = useRef(null);
    const { dark, toggleTheme } = useLandingTheme();

    useLandingMotion(rootRef);

  return (
    <div className="lp" data-theme={dark ? "dark" : "light"} ref={rootRef}>
        <Seo title={title} description={description} path={path} jsonLd={jsonLd}></Seo>
        <Helmet>
            <body className={dark ? "lp-body lp-body-dark" : "lp-body"} />
            <meta name="theme-color" content={dark ? "#120b14" : "#fbfaf7"} />
        </Helmet>

        <LandingNav dark={dark} onToggleTheme={toggleTheme}></LandingNav>

        <main>
            <div className="lp-info-head">
                <div className="lp-hero-bg" aria-hidden="true">
                    <span className="lp-blob lp-blob-1"></span>
                    <span className="lp-blob lp-blob-2"></span>
                </div>
                <div className={"lp-container lp-info-intro lp-hero-intro" + (narrow ? " lp-info-narrow" : "")}>
                    <span className="lp-eyebrow">{eyebrow}</span>
                    <h1>{heading}</h1>
                    {subheading && <p className="lp-lead">{subheading}</p>}
                </div>
            </div>

            {children}
        </main>

        <LandingFooter></LandingFooter>
    </div>
  )
}

export default InfoLayout
